import React, { useId } from 'react'
import { FieldHint, FieldLabel, inputClass } from './TextInput'

const Select = ({
  label,
  labelTopRight,
  labelBottomLeft,
  labelBottomRight,
  value,
  onChange,
  placeholder,
  options,
  name,
  required,
  defaultValue,
}) => {
  const id = useId()
  return (
    <div className="w-full">
      <FieldLabel
        label={label}
        labelTopRight={labelTopRight}
        required={required}
        htmlFor={id}
      />
      <select
        id={id}
        name={name}
        className={inputClass}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        required={required}
        defaultValue={defaultValue}
      >
        <option value="">{placeholder}</option>
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      <FieldHint
        labelBottomLeft={labelBottomLeft}
        labelBottomRight={labelBottomRight}
      />
    </div>
  )
}

export default Select
